export const PERMISSIONS = {
  ADMIN: 'Admin',
  READ_ONLY: 'Read Only',
  STANDARD: 'Standard',
};
